import Grid from '@mui/material/Grid';
import ShippingPendingDatagridComponent from './_sections/_datagrid/ShippingPendingDatagridComponent';
import ShippingPendingFooterComponent from './_sections/_footer/ShippingPendingFooterComponent';
import ShippingHeaderComponent from './_sections/_header/ShippingHeaderComponent';

const ShippingPendingComponent = () => {
  return (
    <Grid container>
      <ShippingHeaderComponent />
      <ShippingPendingDatagridComponent />
      <ShippingPendingFooterComponent />
    </Grid>
  );
};

export default ShippingPendingComponent;
